import styled from 'styled-components';
import { breakpoints } from 'src/constants/breakpoints';
import { PageContainer } from '../GenericComponents/PageContainer';
import primitives from '@veneer/primitives';

export const Container = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-width: 64rem;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;

  @media only screen and (max-width: ${breakpoints.smalldesktop}) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const Title = styled.h1<{ isRTL?: boolean }>`
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  font-weight: 500;

  @media only screen and (max-width: ${breakpoints.tablet}) {
    display: flex;
    justify-content: center;
  }

  @media only screen and (max-width: ${breakpoints.smalldesktop}) {
    text-align: center;
  }
`;

export const ContainerGraphic = styled.div`
  display: flex;
  padding-top: 5vw;

  img {
    min-width: 13.75rem;
    align-self: center;
    padding-bottom: 0.8rem;
    text-align: center;
    margin: 0 5rem 0 0;

    &.hpx {
      filter: hue-rotate(46deg);
    }
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: center;
    padding-top: 10px;

    img {
      margin: 16px 0 0 0;
    }
  }
`;

export const ContainerBody = styled.div`
  max-width: 44.5rem;
  color: #4e4e4e;

  p {
    margin: 16px 0;
    > a {
      color: #027aae;
      :hover {
        color: #006691;
      }
      :active {
        color: #004f74;
      }
    }
  }

  &.hpx {
    a {
      color: ${primitives.color.royalBlue7};
      :hover {
        color: ${primitives.color.royalBlue8};
      }
      :active {
        color: ${primitives.color.royalBlue9};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    text-align: center;
    max-width: 34.5rem;
  }
`;

export const ContainerButton = styled.div<{ isRTL?: boolean }>`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  > button {
    margin-right: 16px;
  }

  &.hpx {
    justify-content: space-between;

    @media only screen and (max-width: ${breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: center;
    }
  }

  &.hpsmart {
    margin-top: 16px;

    @media only screen and (max-width: ${breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
    }
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    > button {
      margin-right: 0;
      margin-top: 10px;
    }
  }

  button:after {
    content: ' ';
    opacity: 0;
    position: absolute;
    inset: 0px;
  }
`;

export const GroupButton = styled.div`
  display: flex;

  .hp-support-button {
    margin-right: 16px;
  }

  @media only screen and (max-width: ${breakpoints.tablet}) {
    display: flex;
    flex-direction: column-reverse;

    .hp-support-button {
      margin-right: 0;
      margin-top: 10px;
    }
  }
`;
